import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { ISettingsDTO } from "../../shared/DTOs/ISettingsDTO";
import { SettingsService } from "../services/settings.service";

@Injectable({
  providedIn: "root",
})
export class FreeSubscriptionGuard implements CanActivate {
  constructor(
    private router: Router,
    private settingsService: SettingsService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return FreeSubscriptionGuard.isFreeSubscription(this.settingsService).pipe(
      map((isFreeSubscription) =>
        isFreeSubscription ? this.router.createUrlTree(["/free-subscription"]) : true,
      ),
    );
  }

  static isFreeSubscription(
    settingsService: SettingsService,
  ): Observable<boolean> {
    return settingsService.settings$.pipe(
      filter((settings): settings is ISettingsDTO => settings !== null),
      take(1),
      map((settings) => settings.subscription?.price === 0),
    );
  }
}
